import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Upload, message } from "antd";
import axios from "axios"; // Import axios for making HTTP requests
import React, { useEffect, useState } from "react";
import { serverUrl } from "../../nestserver";

import { uploadDoc } from "../../services/upload.service";
const MultipleUpload = ({
  onFileListChange,
  onUpload,
  parentResponse,
  isDisabled,
  isParentView,
}) => {
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    onFileListChange && onFileListChange(fileList);
    onUpload && onUpload(fileList);
  }, [fileList, onFileListChange, onUpload]);
  useEffect(() => {
    if (parentResponse) {
      setFileList(parentResponse);
    }
  }, []);

  function beforeUpload(file) {
    const isLt2M = file.size / 1024 / 1024 < 1;
    const isPdf = file.type === "application/pdf";
    if (!isLt2M) {
      message.error("File must be smaller than 1MB!");
    }
    if (!isPdf) {
      message.error(`${file.name} is not a PDF file`);
    }
    return isLt2M && isPdf;
  }

  async function handleUpload(data) {
    try {
      setLoading(true);
      const res = await uploadDoc(data);
      if (res) {
        setFileList((oldArray) => [...oldArray, res]);
      }
      setLoading(false);
      message.success("File uploaded successfully");
    } catch (error) {
      setLoading(false);
      message.error(error.message);
    }
  }

  const handleDelete = (file) => {
    const newFileList = fileList.filter((item) => item.id !== file.id);
    setFileList(newFileList);
  };

  const name = "yourFileName";

  return (
    <div>
      <Upload
        name={name}
        action={serverUrl + "/uploads/docs"}
        multiple
        showUploadList={false}
        customRequest={handleUpload}
        beforeUpload={beforeUpload}
      >
        {loading ? (
          "Uploading..."
        ) : (
          <div className="pt-2">
            <Button
              size="large"
              type="primary"
              htmlType="button"
              disabled={isParentView && isDisabled}
            >
              <UploadOutlined /> Click to Upload
            </Button>
          </div>
        )}
      </Upload>
      {fileList && fileList.length > 0 && (
        <div>
          <p className="pt-2 text-base">Selected Files:</p>
          <ul>
            {fileList &&
              fileList?.length > 0 &&
              fileList?.map((file) => (
                <>
                  <li
                    key={file?.id}
                    className="flex justify-between items-center"
                    style={{ cursor: "pointer" }}
                  >
                    <a
                      href={file?.files.original}
                      target="_blank"
                      rel="noreferrer"
                      className="text-base"
                    >
                      {" "}
                      {file?.files?.name ? file?.files?.name : "none"}
                    </a>
                    <Button
                      type="danger flex items-center justify-center mb-3"
                      shape="circle"
                      icon={<DeleteOutlined />}
                      disabled={isParentView && isDisabled}
                      onClick={() => handleDelete(file)}
                    />
                  </li>
                </>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MultipleUpload;
